import jQuery from 'jquery'
import Application from './application'
import modal from './components/utils/Dialog'
import confirm from './components/utils/Confirm'
import snackbar from './components/utils/Snackbar'

export default {
    name: 'app',
    components: { modal, confirm, snackbar },
    data: () => ({
        role: null,
        username: null,
        showDrawer: false,
        clipped: true,
        drawer: false,
        fixed: false,
        isLoggedIn: false,
        currentYear: new Date().getFullYear(),
        menus: [
            { icon: 'home', title: 'Dashboard', to: 'dashboard', roles: ['Admin', 'Monitor', 'Estadisticos', 'Graduados'] },
            { icon: 'remove_red_eye', title: 'Monitoría', to: 'monitoria', roles: ['Admin', 'Monitor'] },
            { icon: 'dvr', title: 'Pre Monitoría', to: 'premonitoria', roles: ['Admin', 'Estadisticos'] },
            { icon: 'school', title: 'Graduados', to: 'graduados', roles: ['Admin', 'Graduados', 'Estadisticos'] },
            { icon: 'calendar_today', title: 'Período de Graduación', to: 'periodoGraduacion', roles: ['Admin'] },
            { icon: 'assignment', title: 'Manejo de Certificaciones', to: 'certificaciones', roles: ['Admin'] },
            { icon: 'card_membership', title: 'Diplomas', to: 'diplomas', roles: ['Admin', 'Monitor', 'Estadisticos', 'Graduados'] },
            { icon: 'dvr', title: 'Comunicaciones Oficiales', to: 'documentos', roles: ['Admin', 'Estadisticos'] },
            { icon: 'group', title: 'Usuarios', to: 'user', roles: ['Admin'] }
        ],
        miniVariant: false,
        //right: true,
        //rightDrawer: false,
        title: 'Monitoría Cohorte Ajustada Tasa Graduación'
    }),
    mounted() {
        this.$root.$dialog = this.$refs.dialog.open
        this.$root.$confirm = this.$refs.confirm.open
        this.$root.$snackbar = this.$refs.snackbar.open
        this.IsLoggedIn()
    },
    methods: {
        IsLoggedIn() {
            var instance = this
            if (this.$router.currentRoute.path === '/resetPassword')
                return;
            jQuery.ajax({
                url: Application.BaseUrl + '/Account/IsLoggedIn',
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                success: function (data, status, jqxhr) {
                    if (data.Status === 'Authorized') {
                        instance.isLoggedIn = true
                        instance.role = data.Role
                        instance.username = data.UserName
                    }
                },
                error: function (jqxhr, status, error) {
                    instance.$router.replace('/')
                }
            })
        },
        RouteUser() {

            console.log(this.role);

            this.showDrawer = true
            if (this.$router.currentRoute.path === '/') {
                if (this.role === 'Admin')
                    this.$router.replace('/dashboard')
                else if (this.role === 'Monitor' || this.role === 'Estadisticos')
                    this.$router.replace('/dashboard')
                else if (this.role === 'Graduados')
                    this.$router.replace('/dashboard')
                else if (this.role === 'Diploma')
                    this.$router.replace('/diplomas')
                else
                    this.$router.replace('/')
            }
            else if (this.$router.currentRoute.path === '/dashboard')
                this.$children[0].$children[1].$children[0].LoadGraphics()
        },
        logOff() {
            var instance = this
            if (this.showDrawer) {
                this.drawer = !this.drawer;
                jQuery.ajax({
                    url: Application.BaseUrl + '/Account/ApplicationLogOff',
                    crossDomain: true,
                    success: function (data, status, jqxhr) {
                        instance.logOffSuccess()
                    },
                    error: function (jqxhr, status, error) {
                        //instance.$router.replace('/')
                    }
                })
            }
        },
        logOffSuccess() {
            this.isLoggedIn = false;
            this.$root.$snackbar('Adios ' + this.username + '!', { color: 'info' })
            this.username = null
            this.role = null
            this.$router.replace('/')
        }
    },
    watch: {
        role(val, old) {
            this.RouteUser()
        }
    },
    computed: {
        isAdmin() {
            return this.role == 'Admin'
        },
        isMonitor() {
            return this.role == 'Monitor'
        },
        isEstadisticos() {
            return this.role == 'Estadisticos'
        },
        isGrad() {
            return this.role == 'Graduados'
        },
        isDiploma() {
            return this.role == 'Diploma'
        }
    }
}


// WEBPACK FOOTER //
// ./src/script.js